import qs from "qs"

import { httpPost } from "../http"

export interface V1CompletedBookingBody {
  start_from: number
}

export interface V1CompletedBookingResponse {
  flag: number
  data: HistoryRide[]
  history_size: number
}

export interface HistoryRide {
  pickup_address: string
  drop_address: string
  drop_location_address: string
  ride_type: number
  manually_edited: ManuallyEdited
  vehicle_type: number
  driver_id: number
  distance: number
  wait_time: number
  is_cancelled_ride: number
  ride_time: number
  amount: number
  autos_status: number
  pickup_time?: string
  created_at: string
  product_type: number
  autos_status_color: string
  autos_status_text_color: string
  autos_status_text: string
  customer_fare_factor: number
  cancellation_charges: number
  date: string
  images: Images
  region_name: string
  is_rated_before: number
  engagement_id: number
  user_id: number
  currency: string
  distance_unit: string
  utc_offset: string
  pickup_latitude: number
  pickup_longitude: number
  drop_latitude: number
  drop_longitude: number
  driver_rating: number
  rental_duration?: any
  actual_duration?: any
  stop_points: any[]
  scheduled_for?: any
  insurance_fee?: any
  insurance_cert_url?: any
  vehicle_name: string
  debt_money: number
  accept_time: string
}

export interface Images {
  active_session: string
  tab_normal: string
  tab_highlighted: string
  trip_detail_icon: string
  invoice_icon: string
  marker_icon: string
  schedule_highlighted: string
}

export interface ManuallyEdited {
  text: string
  background_color: string
  text_color: string
}

export async function v1FetchCompletedBookingActivities(
  body: V1CompletedBookingBody,
  options?: { formUrlEncoded?: boolean }
): Promise<V1CompletedBookingResponse> {
  const isForm = Boolean(options?.formUrlEncoded)
  const data = isForm ? qs.stringify(body) : body
  const headers = isForm
    ? { "Content-Type": "application/x-www-form-urlencoded" }
    : { "Content-Type": "application/json" }

  const resp = await httpPost<V1CompletedBookingResponse>(
    "be-autos/autos_integrated_order_history",
    data,
    { headers }
  )
  return resp.data
}

export async function v1FetchWaitingBookingActivities(): Promise<any> {
  const resp = await httpPost(
    "be-autos/scheduled_bookings/customer/upcoming_bookings"
  )
  return resp.data
}
